/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { ReactElement } from 'react';
import MatchedVisasItemMobileExperiment1 from './MatchedVisasItemMobile-experiment-1';
import { placeholderVisaData } from '../../../../../../data/constants/constants';
import { Carousel } from 'react-responsive-carousel';
// import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
// import ColorfulBtn from 'views/UserDashboard/UserDashboardV4/components/BookACallButton/colorfulBtn';
// import { ReactComponent as CrossSimpleIcon } from 'assets/icons/cross-simple.svg';
// import IconBtn from 'components/common/IconBtn';
import './MatchedVisasDashboard-Mobile-experiment-1.scss';

type MatchedVisasDashboardMobileProps = {
    assessmentScore: any[];
    matchedVisasModalOpen: boolean;
    handleMatchedVisasClick: () => void;
    paid: boolean;
};

export function MatchedVisasDashboardMobileE1({
    assessmentScore,
    matchedVisasModalOpen,
    handleMatchedVisasClick,
    paid,
}: MatchedVisasDashboardMobileProps): ReactElement | null {
    const isAssessmentScoreEmpty = assessmentScore.length === 0;
    const relevantData = isAssessmentScoreEmpty ? placeholderVisaData : assessmentScore;

    // const listItems = [
    //     'Analyze your assessment report with an expert.',
    //     'Get expert advice on your top visa options.',
    //     'Fully streamlined & transparent visa process.',
    //     '24 X 7 support with your full visa application.',
    // ];

    // const getListItems = (items: string[]) => {
    //     return items.map((item, i) => (
    //         <>
    //             <div className="stage__icon">
    //                 <CheckIcon className="check" />
    //             </div>
    //             <div className="grid-item-E1">{item}</div>
    //         </>
    //     ));
    // };

    return (
        <>
            <span className="carouselSection" onClick={handleMatchedVisasClick}>
                <div className="MatchedVisasBody">
                    <Carousel
                        className="carrousel carrouselMobile"
                        infiniteLoop={true}
                        autoPlay={true}
                        showStatus={false}
                        // showArrows={false}
                        interval={5000}
                        centerMode={true}
                        showThumbs={false}
                        // selectedItem={2}
                        centerSlidePercentage={100}
                    >
                        {relevantData.map((item: any) => (
                            <MatchedVisasItemMobileExperiment1
                                key={item.country}
                                countryVisaData={item}
                                isAssessmentScoreEmpty={isAssessmentScoreEmpty}
                                paid={paid}
                            />
                        ))}
                    </Carousel>
                </div>
            </span>
            {/* {matchedVisasModalOpen && (
                <div className="ClickableVisasInfo">
                    <div className="Header3">
                        <IconBtn
                            className="closeButton"
                            onClick={handleMatchedVisasClick}
                            style={{ paddingBottom: '0px' }}>
                            <CrossSimpleIcon className="Cross" />
                        </IconBtn>
                    </div>
                    <div>
                        <p className="InfoParagraph">
                            Get expert consultation to unlock success chances of individual
                            programs.
                        </p>
                    </div>
                </div>
            )} */}
            {/* 
            <div className="BenefitsSection" style={{ marginTop: '2rem' }}>
                <div className="Header2">
                    <span className="Title">Benefits of expert consultation:</span>
                </div>
                <div className="grid-container2">{getListItems(listItems)}</div>
            </div> */}

            {/* <div className="GuaranteeContainer">
                <p className="Guarantee">
                    Aliro promises <span className="bold">100%</span> service satisfaction
                    guarantee**
                </p>
            </div> */}
        </>
    );
}

export default MatchedVisasDashboardMobileE1;
